export enum TaxDivisionEnum {
  // 課税区分
  /** 課税10% */ RATE_TEN = '1',
  /** 課税8% */ RATE_EIGHT = '2',
  /** 免税（非課税） */ TAX_FREE = '3', // TODO
  /** 対象外 */ NOT_APPLICABLE = '4',
}
